import React from "react";
import { Link } from "react-router-dom";

const AgencyWelcomePanel = ({ to, image, subtitle, title, mailTo = null, height='220px', onClick = null }) => (
  <Link to={to} className="block hover:shadow-lg" style={{ borderRadius: "16px", overflow: "hidden", display: "block" }} onClick={(e) => {
    if(onClick) {
      onClick(e);
      return;
    }
    if(mailTo)
    {
      window.location.href = mailTo;
      e.preventDefault();
    }
  }}>
    <div
      style={{
        position: "relative",
        height: height,
        borderRadius: "16px",
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div style={{ position: "absolute", bottom: 0, left: 0, padding: "24px" }}>
        <h3 className={'text-3xl mb-0 font-bold text-white 2xl:text-4xl'}>{title}</h3>
        <p  className={'text-xl mb-0 font-bold text-white xl:text-xl'}>{subtitle}</p>
      </div>
    </div>
  </Link>
);

export default AgencyWelcomePanel;
